export default __webpack_public_path__ + "static/avatar-tag-do-light-e8fe741cfc8d89636a3b81961e651572560349ff3f1893878906e6903e6be1f2.png";